import { Delegation, DelegationsRequestArgs } from "@decibeltrade/sdk";
import { FetchQueryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { useUserPreferences } from "@/hooks/use-user-preferences";

import { readDexSdk } from "../dex-sdk";
import { DelegationMetadata } from "../mutations/update-user-preferences";

export interface DelegationWithMetadata extends Delegation {
  metadata: DelegationMetadata | undefined;
}

export const DELEGATIONS_QUERY_KEY = "delegations";

export function delegationsQueryKey({ subAddr }: DelegationsRequestArgs) {
  return [DELEGATIONS_QUERY_KEY, subAddr];
}

export function delegationsQuery(args: DelegationsRequestArgs) {
  return {
    queryKey: delegationsQueryKey(args),
    queryFn: () => readDexSdk.delegations.getAll(args),
  } satisfies FetchQueryOptions;
}

export const useUserDelegations = (args: DelegationsRequestArgs) => {
  const { delegationsMetadata } = useUserPreferences();

  const suspenseQuery = useSuspenseQuery(delegationsQuery(args));

  const delegations = suspenseQuery.data;

  const delegationsWithMetadata: DelegationWithMetadata[] = useMemo(
    () =>
      delegations.map((delegation) => ({
        ...delegation,
        metadata: delegationsMetadata[delegation.delegated_account],
      })),
    [delegations, delegationsMetadata],
  );

  return {
    ...suspenseQuery,
    data: delegationsWithMetadata,
  };
};
